export default __webpack_public_path__ + "static/media/des-2.d59cc1f0.jpg";